﻿import CacheService from './CacheService';

export const useCacheStore = defineStore('cache', () => {
    const Users = ref(null);
    const Settings = ref(null);
    const UserSettings = ref(null);

    async function Update() {
        Users.value = await CacheService.GetUsers();
        Settings.value = await CacheService.GetSettings();
        UserSettings.value = await CacheService.GetUserSettings();
    }

    async function GetUsers(inactive = false, role = null) {
        if (!Users.value) {
            await Update();
        }

        let users = inactive ? Users.value : Users.value.filter(u => u.Active);

        if (role) {
            users = users.filter(u => u.Roles.indexOf(role) > -1);
        }

        return users;
    }

    function GetUserDisplayName(id) {
        let user = GetUserById(id);
        if (!user) return '';
        return user.DisplayName;
    }

    function GetUserById(id) {
        if (!id) return null;
        var user = Users.value.find(u => u.Id == id);
        return user;
    }

    return {
        Update,
        GetUsers,
        GetUserDisplayName,
        GetUserById,
        Users,
        Settings,
        UserSettings,
    }
}, {
    persist: {
        key: 'municrm.cache',
        storage: window.sessionStorage,
    },
})